import * as React from 'react';
import { Translate } from 'react-jhipster';
import { Row, Col } from 'reactstrap';

export class Faq extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Row className="justify-content-center">
        <Col md="8" className="bg-white">
          <Row className="justify-content-center">
            <Col md="8" className="m-3">
              <h1>
                <Translate contentKey="static.faq.title">常見問題</Translate>
              </h1>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q1">PATO ENTERTAINMENT 接受甚麼付款方法 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a1">PATO ENTERTAINMENT現時接受以 VISA 及 MASTERCARD 的信用卡支付方式。</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q2">每次交易最多可以訂購多少張門票 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a2">除個別情況外，每次交易最多可購買8張門票。</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q3">入場年齡有限制嗎 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a3">年齡限制視乎個別演出而定，必須一人一票入場。</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q4">購票需付手續費嗎 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a4">經網上系統或電話購票，客戶須支付手續費每張門票 $10。</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q5">購票需付郵費嗎 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a5">
                  如演出只支援電子票，不需支付額外郵費。如演出為實體門票，每個訂單需支付郵費，郵費視乎個別演出而定。
                </Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q6">購票時可以選擇座位嗎 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a6">
                  如演出屬劃位座席，系統會自動從該票區中分配訂購時的最佳位置，不設個別座位選擇。
                </Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q7">如何購買輪椅座位 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a7">
                  如需購買輪椅座位，請與客戶服務部聯絡，以便作出特別安排。電郵至 info@patotix.com ，或於辦公時間
                  (星期一至五,上午10時至下午6時) 致電客戶服務熱線 +852 5667 6376。
                </Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q8">訂購時為甚麼要輸入保安問題 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a8">
                  訂購時需設定3條保安問題，如演出現場出示之電子門票有爭議，職員有權要求閣下提供訂購者資料及保安問題答案以確認身份。
                </Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q9">購票成功後，我可以要求取消訂單嗎 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a9">
                  不可以。除有關活動／演出／表演延期外，訂單一經確認，恕不能取消、轉換或退款。
                </Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q10">電子票何時寄出 ?</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a10">演出的電子票將於演出前14天左右，系統以電郵發送至訂購時的電子郵箱，</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q11">如演出取消，可以獲發退款嗎？</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a11">
                  如演出需要取消，主辦單位會發出公告取消及退款程序。PATO ENTERTAINMENT將跟據主辦單位訂立之退款程序處理客戶退款事宜。"
                </Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q12">12</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a12">12</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q13">13</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a13">13</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q14">14</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a14">14</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q15">15</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a15">15</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q16">16</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a16">16</Translate>
              </p>
              <p>
                <strong>
                  <u>
                    <Translate contentKey="static.faq.q17">17</Translate>
                  </u>
                </strong>
              </p>
              <p>
                <Translate contentKey="static.faq.a17">17</Translate>
              </p>
              <p>
                <Translate contentKey="static.faq.general">general</Translate>
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    );
  }
}

export default Faq;
